import { BaseReducerState } from '../../../services'
import { ActionTypes } from '../actions'
import { PaymentListDto, PaymentListResponse } from '../../../content/applications/PaymentHistory/Services'

export type PaymentListState = BaseReducerState & {
  data: PaymentListDto[] | null
}

export const initialState: PaymentListState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const fetchPaymentList = (
  state: PaymentListState = initialState,
  action: { type: string; res: any }
): PaymentListState => {
  switch (action.type) {
    case `${ActionTypes.FETCH_PAYMENT_LIST}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        data: state.data,
        error: null,
      }

    case `${ActionTypes.FETCH_PAYMENT_LIST}_SUCCESS`: {
      const { success, data, message } = <PaymentListResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
        ...(success && data && { data }),
      }
    }
    case `${ActionTypes.FETCH_PAYMENT_LIST}_FAILURE`:
      const res = <PaymentListResponse>action.res
      const { message } = res || {}
      res.error ??= message
      const { error } = res
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
      }

    case `${ActionTypes.FETCH_PAYMENT_LIST}_RESET`:
      return {
        ...initialState,
      }
  }
  return state
}
